"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "bettola": {
    "bd8cad6a": [{
      "hkey": "64603c33",
      "slug": "bettola",
      "name": "Bettola",
      "primary": true,
      "skipSearch": false
    }],
    "bramaiano": [{
      "hkey": "64603c33",
      "slug": "bettola",
      "name": "Bettola",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "736324af": [{
      "hkey": "64603c33",
      "slug": "bettola",
      "name": "Bettola",
      "primary": true,
      "skipSearch": false
    }],
    "calenzano": [{
      "hkey": "64603c33",
      "slug": "bettola",
      "name": "Bettola",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "8dce6f4f": [{
      "hkey": "7ecd8f2b",
      "slug": "missano",
      "name": "Missano",
      "primary": true,
      "skipSearch": false
    }],
    "leggio-missano": [{
      "hkey": "7ecd8f2b",
      "slug": "missano",
      "name": "Missano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "546f446a": [{
      "hkey": "64603c33",
      "slug": "bettola",
      "name": "Bettola",
      "primary": true,
      "skipSearch": false
    }],
    "pradello": [{
      "hkey": "64603c33",
      "slug": "bettola",
      "name": "Bettola",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1baf2619": [{
      "hkey": "64603c33",
      "slug": "bettola",
      "name": "Bettola",
      "primary": true,
      "skipSearch": false
    }],
    "roncovero": [{
      "hkey": "64603c33",
      "slug": "bettola",
      "name": "Bettola",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;